import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { Box, Button } from "@mui/material";
import styles from "../movein-checklist.module.css";
import { DownloadCloud } from "react-feather";

const MoveInChecklistPDF = ({ moveInChecklistPDFContent }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const base64 = moveInChecklistPDFContent?.file_content;
  const s3Url = moveInChecklistPDFContent?.file_url;

  const isValidBase64 = base64 && base64.length > 100;

  const fileUrl = isValidBase64
    ? `data:application/pdf;base64,${base64}`
    : s3Url;

  return (
    <div className={`${styles.ConAreaSidePanel}`}>
      {s3Url && (
        <a href={s3Url} target="_blank" rel="noopener noreferrer" download className={`${styles.ChecklistDownloadBU}`}>
          <DownloadCloud />Download PDF
        </a>
      )}

      <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
        <Box style={{ height: "100%", width: "100%" }}>
          {fileUrl ? (              
            <Viewer defaultScale={1} fileUrl={fileUrl} />            
          ) : (
            <div className={`${styles.NoDataMain}`}>
              <div className={`${styles.NoDataIMG}`}>
                <img src="/static/img/pdf-checklist.png" alt="No Data" />
              </div>
              <p className={`${styles.NoDataText}`}>Unfortunately!</p>
              <p className={`${styles.NoDataTextSub}`}>PDF not available at this time.</p>
            </div>
          )}
        </Box>
      </Worker>
    </div>
  );
};

export default MoveInChecklistPDF;
